import { network } from 'services/network';

export const getList = () => {
    return network.post('api/bo/notification/getList').then((response) => (response.data === '' ? [] : response.data));
};
